import type { Role } from '../../types';
import basicUser from './basic-user.md?raw';
import reviewer from './reviewer.md?raw';
import frameworkManager from './framework-manager.md?raw';
import admin from './admin.md?raw';
import concepts from './concepts.md?raw';

export const ROLE_CONTENT: Record<Role, string> = {
  'basic-user': basicUser,
  reviewer,
  'framework-manager': frameworkManager,
  admin,
};

export const CONCEPTS_CONTENT = concepts;
